var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.4084V9.24728C17.5 5.67344 17.5 3.88652 16.4017 2.77627C15.3033 1.66602 13.5355 1.66602 10 1.66602C6.46447 1.66602 4.6967 1.66602 3.59835 2.77627C2.5 3.88652 2.5 5.67344 2.5 9.24728V13.4084C2.5 15.9889 2.5 17.2791 3.11176 17.8429C3.40351 18.1118 3.77179 18.2807 4.1641 18.3256C4.98668 18.4198 5.94728 17.5701 7.86847 15.8709C8.71768 15.1198 9.14229 14.7442 9.63356 14.6452C9.87548 14.5965 10.1245 14.5965 10.3664 14.6452C10.8577 14.7442 11.2823 15.1198 12.1315 15.8709C14.0527 17.5701 15.0133 18.4198 15.8359 18.3256C16.2282 18.2807 16.5965 18.1118 16.8882 17.8429C17.5 17.2791 17.5 15.9889 17.5 13.4084Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5H7.5",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationCreate);
export default __webpack_public_path__ + "static/media/ReservationCreate.f5446ff4dfd1050268ff3ebc5caab83a.svg";
export { ForwardRef as ReactComponent };